// stores/session.js
import { defineStore } from 'pinia'
import api from '@/services/api' // <-- import your API helper

export const SESSION_LOGOUT_EVENT = 'netflyr:logout'

export const useSessionStore = defineStore('session', {
  state: () => ({
    user: null,           // Logged-in user (includes token etc.)
    profile: null,        // ✅ Detailed profile data (fetched separately)
    loadingProfile: false // optional loading flag
  }),

  getters: {
    isLoggedIn: (state) => !!state.user,
    userId: (state) => state.user?.id || state.user?.user_id || state.user?.userid || state.user?.uid || null,
  },

  actions: {
    // ✅ Persist user object
    setUser(user) {
      this.user = user
      localStorage.setItem('user', JSON.stringify(user))
    },

    // ✅ Restore from localStorage
    loadUser() {
      const savedUser = localStorage.getItem('user')
      if (savedUser) {
        try {
          this.user = JSON.parse(savedUser)
        } catch (e) {
          console.error('Failed to parse user from localStorage:', e)
          this.user = null
          localStorage.removeItem('user')
        }
      } else {
        this.user = null
      }
    },

    // ✅ Logout
    logout() {
      this.user = null
      this.profile = null
      localStorage.removeItem('user')
      if (typeof window !== 'undefined') {
        window.dispatchEvent(new CustomEvent(SESSION_LOGOUT_EVENT))
      }
    },

    // ✅ Fetch full profile (from your backend)
    async fetchProfile(force = false) {
      if (!this.userId) return null

      // Don’t refetch if we already have profile unless forced
      if (this.profile && !force) return this.profile

      try {
        this.loadingProfile = true
        const formData = new FormData()
        formData.append('id', this.userId)

        const { data } = await api.getProfileApi(formData)
        if (data.status === 'ok' && data.data?.[0]) {
          this.profile = data.data[0]
          return this.profile
        }
      } catch (err) {
        console.error('Profile fetch failed:', err)
      } finally {
        this.loadingProfile = false
      }
      return null
    },

    // ✅ Update local profile (after settings save)
    updateProfileLocally(updatedData) {
      if (this.profile) {
        this.profile = { ...this.profile, ...updatedData }
      } else {
        this.profile = updatedData
      }
    },
  },
})
